// extracted by mini-css-extract-plugin
export default {"bottomNav":"BottomNavBar_bottomNav__o7nfb","navItem":"BottomNavBar_navItem__+j+rK","active":"BottomNavBar_active__qEA4s","navIcon":"BottomNavBar_navIcon__sBa2+"};